import * as React from "react";
import { memo } from "react";

const SvgWifi = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.984.801C7.026.837 3.602 2.204.744 4.958c-.112.107-.222.207-.387.19-.154-.016-.277-.096-.329-.24-.06-.167-.026-.319.11-.453A14.622 14.622 0 0 1 2.103 2.8C4.94.828 8.084-.117 11.533.01c3.996.15 7.426 1.65 10.297 4.433.206.2.225.436.057.609-.168.172-.41.159-.617-.048a14.275 14.275 0 0 0-3.183-2.392 14.5 14.5 0 0 0-6.29-1.81c-.27-.015-.54-.002-.813-.002Z"
      fill="#000"
    />
    <path
      d="M11.02 3.13c3.326.043 6.207 1.187 8.606 3.51.16.154.222.325.11.524-.101.183-.27.224-.466.172-.078-.02-.13-.073-.183-.126-1.748-1.705-3.822-2.793-6.231-3.157-3.733-.562-7.004.454-9.791 3.013-.055.05-.109.104-.165.155-.195.178-.421.183-.58.015-.16-.168-.149-.393.037-.58.338-.342.698-.66 1.08-.952C5.6 4.046 8.043 3.188 10.77 3.13c.085-.002.167 0 .25 0Z"
      fill="#000"
    />
    <path
      d="M10.999 6.242c2.412.043 4.516.86 6.288 2.516a.918.918 0 0 1 .234.301c.079.179.09.333-.082.46a.402.402 0 0 1-.535-.031c-.588-.605-1.27-1.08-2.01-1.477-3.16-1.698-7.164-1.13-9.727 1.38-.225.22-.455.244-.632.066s-.15-.417.091-.644C6.41 7.119 8.537 6.278 11 6.243Z"
      fill="#000"
    />
    <path
      d="M10.983 9.37c1.601.027 2.995.57 4.168 1.67.156.145.25.305.172.518-.105.29-.443.323-.701.072-.621-.601-1.344-1.041-2.18-1.262-1.922-.508-3.628-.09-5.096 1.26-.163.15-.332.208-.529.096-.175-.098-.211-.262-.169-.449.022-.092.086-.157.15-.22 1.175-1.11 2.575-1.658 4.185-1.686ZM11.016 15.663a1.58 1.58 0 0 1-1.6-1.6 1.6 1.6 0 1 1 1.6 1.6Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgWifi);
export default Memo;
